/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import cx from 'classnames';

import { SortIcon } from '../icon/SortIcon';

interface CenteredHeaderProps<D extends object> {
    column: SortableColumn<D>;
}

export function CenteredHeader<D extends object>({
    column,
}: CenteredHeaderProps<D>): JSX.Element {
    const { isSorted, isSortedDesc, headerLabel, headerSubLabel } = column;

    // Using a transparent bottom border when the header is not sorted prevents any layout shift
    // between isSorted / !isSorted states
    const headerClasses = cx('w-full h-full font-semibold text-xs', {
        'text-black': isSorted,
    });

    let body = (
        <div className={cx({ underline: isSorted })}>
            <span className="pr-1">{headerLabel}</span>
            <SortIcon isSorted={isSorted} isSortedDesc={isSortedDesc} />
        </div>
    );

    if (headerSubLabel) {
        body = (
            <div className={cx('flex flex-col', { underline: isSorted })}>
                <p>{headerLabel}</p>
                <p>
                    {headerSubLabel}{' '}
                    <SortIcon isSorted={isSorted} isSortedDesc={isSortedDesc} />
                </p>
            </div>
        );
    }

    return (
        <div className={headerClasses}>
            <div className="w-full h-full mb-1 flex justify-center">{body}</div>
        </div>
    );
}
